import * as React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import './Loader.scss';

export default function CircularStatic(props) {
  const size = props.size || (props.value != null ? 84 : 48);
  const thickness = props.thickness || 4;
  const hasProgress = props.value != null && !Number.isNaN(props.value);

  if (!hasProgress) {
    return (
      <CircularProgress
        size={size}
        thickness={thickness}
        color="primary"
      />
    );
  }

  const value = Math.min(100, Math.max(0, props.value));

  return (
    <Box className="loader-progress" sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={value}
        size={size}
        thickness={thickness}
        color="primary"
      />
      <Box
        className="loader-progress-label"
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" className="loader-progress-text">
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
